import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import WarningIcon from "@mui/icons-material/Warning";
import React from "react";

/**
 * Diálogo de confirmação para deletar tipo de documento
 * @param {object} props
 * @param {boolean} props.isOpen - Se o diálogo está aberto
 * @param {function} props.onClose - Callback ao fechar
 * @param {object} props.documentType - Tipo de documento a ser deletado
 * @param {function} props.onConfirm - Callback ao confirmar
 */
export default function DeleteConfirmationDialog({
  isOpen,
  onClose,
  documentType,
  onConfirm,
}) {
  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <WarningIcon color="warning" />
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Confirmar Exclusão
          </Typography>
        </Box>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Tem certeza que deseja deletar este tipo de documento?
        </Typography>

        <Box
          sx={{
            p: 1.5,
            bgcolor: "background.default",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "divider",
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
            {documentType?.name}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            Categoria: {documentType?.category}
          </Typography>
        </Box>

        <Box
          sx={{
            p: 1.5,
            bgcolor: "warning.lighter",
            borderRadius: 1,
            border: "1px solid",
            borderColor: "warning.main",
          }}
        >
          <Typography variant="body2" color="warning.dark">
            ⚠️ Esta ação não pode ser desfeita. Todos os documentos deste tipo nos
            projetos existentes permanecerão, mas este tipo não estará mais disponível
            para novos uploads.
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={onConfirm}>
          Deletar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

